export const WELCOME_MESSAGE_SHOWN_KEY = 'welcomeMessageShown'
export const SYSTEM_CONFIG_LOADING_KEY = 'systemConfigLoading'

export const OPERATING_MODE = {
  ROTODOCS: 1,
  MPX_LITE: 2,
  MPX_HOST: 3,
  MPX_PROFESSIONAL: 4,
  MPX_BATCH: 5,
  MPX_ENTERPRISE: 6,
  MPX_NON_STOP: 7,
  MPX_DISTRIBUTION: 8,
}
export const OPERATING_NAME = {
  1: 'Rotodocs',
  2: 'mpx Lite',
  3: 'mpx Host',
  4: 'mpx Professional',
  5: 'mpx Batch',
  6: 'mpx Enterprise',
  7: 'mpx Non Stop',
  8: 'mpx Distribution',
}

export const WMS_MODE = {
  LITE: 0,
  PRO: 1,
  BETA: 'beta',
}
